module.exports = __webpack_public_path__ + "media/images/products/banners/fundos_imobiliários-323d392cd7da841f391d84fbe49cbcb8.png";